/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSphere = createReactComponent("sphere", "IconSphere", [
  ["path", { d: "M3 12c0 1.657 4.03 3 9 3s9 -1.343 9 -3", key: "svg-0" }],
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-1" }]
]);

export { IconSphere as default };
//# sourceMappingURL=IconSphere.js.map
